export default __webpack_public_path__ + "img/c1001.4c7fab5c.svg";